<template>
  <section class="movie-area__wrap" data-scroll-section>
    <div class="movie-area">
      <div class="movie-area__inner l-container">
        <CSectionTitle textColor="white">
          <template v-slot:titleEn>
            INTERVIEW MOVIE
          </template>
          <template v-slot:titleJa>
            インタビュームービー
          </template>
          <template v-slot:bg> </template>
        </CSectionTitle>

        <div class="movie">
          <div
            class="movie__photo"
            @mouseenter="isHover = true"
            @mouseleave="isHover = false"
            @click="openModal"
          >
            <div class="movie__photo-in">
              <svg
                class="movie__play-btn"
                :class="{ 'is-hover': isHover }"
                width="68"
                height="68"
                viewBox="0 0 68 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  :class="{ 'is-hover': isHover }"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M45.9423 34.7603L26 24.6828V23L49 34.7983L26 46V29.1646L27.4808 30.7407V43.7516L45.9423 34.7603Z"
                  fill="#E40718"
                />
                <circle
                  class="circle-back"
                  cx="34"
                  cy="34"
                  r="33"
                  stroke="#E40718"
                  opacity="0.45"
                  stroke-width="1"
                />
                <circle
                  class="circle-front"
                  cx="34"
                  cy="34"
                  r="33"
                  stroke="#E40718"
                  stroke-width="2"
                />
              </svg>

              <img
                :class="{ 'is-hover': isHover }"
                :src="require(`@/assets/movie/${posterImage}`)"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <svg
      data-scroll
      data-scroll-speed="1"
      class="tri"
      width="840"
      height="1112"
      viewBox="0 0 840 1112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter_contents)">
        <path
          d="M63.8444 1023.97L103.439 80L755.94 717L63.8444 1023.97Z"
          fill="#E40718"
        />
      </g>
      <defs>
        <filter
          id="filter_contents"
          x="-20.1556"
          y="0"
          width="860.095"
          height="1111.97"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="42" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>

    <svg
      data-scroll
      data-scroll-speed="1"
      class="tri tri02"
      width="840"
      height="1112"
      viewBox="0 0 840 1112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter_contents)">
        <path
          d="M63.8444 1023.97L103.439 80L755.94 717L63.8444 1023.97Z"
          fill="#E40718"
        />
      </g>
      <defs>
        <filter
          id="filter_contents"
          x="-20.1556"
          y="0"
          width="860.095"
          height="1111.97"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="42" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </section>
</template>

<script>
import CSectionTitle from '@/components/C-SectionTitle.vue'

export default {
  props: {
    openModal: {
      type: Function
    },
    posterImage: {
      type: String
    }
  },

  data() {
    return {
      isHover: false
    }
  },

  components: { CSectionTitle }
}
</script>

<style lang="scss" scoped>
.movie-area {
  position: relative;
  transform: skewY(-6deg);
  padding: 10rem 0 14rem;
  @media screen and (max-width: $breakpoint-mobile) {
    padding: 4rem 0 8rem;
  }

  &__wrap {
    @media screen and (max-width: $breakpoint-mobile) {
      position: relative;
      z-index: 0;
    }
  }

  &__inner {
    transform: skewY(6deg);
  }

  .movie {
    display: flex;
    justify-content: center;
    @media screen and (max-width: $breakpoint-mobile) {
      flex-direction: column;
      margin: 4rem 0 0;
    }
    &__photo {
      transform: skewY(-6deg) translate(5rem, 0px);
      overflow: hidden;
      width: 80rem;
      height: 50rem;
      position: relative;
      z-index: 9;
      cursor: pointer;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        height: 24rem;
        transform: skewY(-6deg) translate(0, 0);
      }
    }

    &__play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 9;
      path {
        transform: scale(1);
        transition: transform 0.9s cubic-bezier(0.4, 0, 0.1, 1);
        transform-origin: center;
      }

      .circle-front {
        stroke-dashoffset: 1000;
        stroke-dasharray: 1000;
        transform: rotate(-200deg);
        transform-origin: 20.5px 20.5px;
        transition: stroke-dashoffset 0.9s cubic-bezier(0.4, 0, 0.1, 1),
          transform 0.9s cubic-bezier(0.4, 0, 0.1, 1);
        transform-origin: center;
      }

      &.is-hover {
        path {
          transform: scale(0.8);
        }
        .circle-front {
          stroke-dashoffset: 790;
          transform: rotate(0deg);
        }
      }
    }

    &__photo-in {
      position: absolute;
      transform: skewY(6deg);
      height: 60rem;
      top: 50%;
      transform: translate(0, -50%) skewY(6deg);
      z-index: -9;

      @media screen and (max-width: $breakpoint-mobile) {
        height: 30rem;
      }

      img {
        width: 100%;
        height: 100%;
        transform: scale(1);
        object-fit: cover;
        transition: transform 0.9s cubic-bezier(0.4, 0, 0.1, 1);
        will-change: transform;
        backface-visibility: hidden;
        &.is-hover {
          transform: scale(1.05);
        }
      }
    }
  }
}

.tri {
  position: absolute;
  top: -20rem;
  left: -25rem;
  z-index: -9;

  @media screen and (max-width: $breakpoint-mobile) {
    top: -20rem;
    left: -20rem;
    width: 50rem;
  }

  &.tri02 {
    top: -30rem;
    right: -30rem;
    left: inherit;
    width: 60rem;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 40rem;
    }
  }
}
</style>
